import React, { useContext, useEffect, useState } from 'react';
import { Button, Input, Card, Row, Col, Icon } from 'antd';

import Layout from '../layout/Layout';
import { Utils } from '../context/UtilsContext';
import CustomerContext from '../context/Customer/CustomerContext';
import CustomersTable from '../components/Customers/CustomersTable';
import CustomersForm from '../components/Customers/CustomersForm';
import searchArray from '../components/searchArray';

const CustomerView = () => {
  const {
    customersVal,
    getCustomers,
    addCustomer,
    updateCustomer,
    deleteCustomer,
  } = useContext(CustomerContext);
  const { setLoading } = useContext(Utils);

  const [modalData, setModalData] = useState({ visible: false, data: {} });
  const [search, setSearch] = useState('');

  const openModal = (data = {}) => setModalData({ data, visible: true });
  const closeModal = () => setModalData({ visible: false, data: {} });

  useEffect(() => {
    if(!customersVal.isLoaded)
      getCustomers(setLoading);
  }, [setLoading, customersVal, getCustomers]);

  const { customers } = customersVal;
  const filteredCustomer = searchArray(search, customers, ['bi_name']);

  // Stats calculation - without optional chaining
  const stats = {
    total: (customers && customers.length) || 0,
    approved: (customers && customers.filter(c => c.isApproved === 'APPROVED' || c.isApproved === 'RECOMMENDED').length) || 0,
    pending: (customers && customers.filter(c => c.isApproved === 'PENDING APPROVAL').length) || 0,
    rejected: (customers && customers.filter(c => c.isApproved === 'REJECTED').length) || 0,
  };

  const cardStyle = {
    borderRadius: 12,
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    border: '1px solid #e8e8e8',
    background: '#fff',
    height: '100%',
  };

  const statCards = [
    { title: 'TOTAL CUSTOMERS', value: stats.total, icon: 'team', color: '#1890ff', bg: '#e6f7ff' },
    { title: 'APPROVED', value: stats.approved, icon: 'check-circle', color: '#52c41a', bg: '#f6ffed' },
    { title: 'PENDING', value: stats.pending, icon: 'clock-circle', color: '#fa8c16', bg: '#fff7e6' },
    { title: 'REJECTED', value: stats.rejected, icon: 'close-circle', color: '#ff4d4f', bg: '#fff1f0' },
  ];

  // Button styles with animation
  const buttonStyles = `
    @keyframes btn-pulse {
      0% {
        box-shadow: 0 0 0 0 rgba(24, 144, 255, 0.4);
      }
      70% {
        box-shadow: 0 0 0 10px rgba(24, 144, 255, 0);
      }
      100% {
        box-shadow: 0 0 0 0 rgba(24, 144, 255, 0);
      }
    }
    
    @keyframes btn-float {
      0% {
        transform: translateY(0px);
      }
      50% {
        transform: translateY(-3px);
      }
      100% {
        transform: translateY(0px);
      }
    }
    
    .animated-add-btn {
      background: #1890ff !important;
      border: none !important;
      color: white !important;
      font-weight: 600 !important;
      height: 36px !important;
      padding: 0 24px !important;
      border-radius: 8px !important;
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1) !important;
      position: relative !important;
      overflow: hidden !important;
    }
    
    .animated-add-btn:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(24, 144, 255, 0.4);
      background: #40a9ff !important;
    }
    
    .animated-add-btn:active {
      transform: translateY(0px);
    }
    
    .animated-add-btn::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
      transition: left 0.5s;
    }
    
    .animated-add-btn:hover::before {
      left: 100%;
    }
  `;

  return (
    <>
      <style>{buttonStyles}</style>
      <br />
      <h4 style={{ fontWeight: 600 }}>CUSTOMERS LIST</h4>
      
      {/* Stat Cards */}
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        {statCards.map((card, idx) => (
          <Col key={idx} xs={24} sm={12} md={12} lg={6}>
            <Card style={cardStyle} bodyStyle={{ padding: '20px 18px' }} bordered={false}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 11, color: '#8c8c8c', fontWeight: 600, letterSpacing: '0.8px', marginBottom: 8, textTransform: 'uppercase' }}>
                    {card.title}
                  </div>
                  <div style={{ fontSize: 30, fontWeight: 700, color: card.color, lineHeight: 1.2 }}>
                    {card.value}
                  </div>
                </div>
                <div style={{ width: 52, height: 52, borderRadius: 12, background: card.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <Icon type={card.icon} style={{ fontSize: 24, color: card.color }} />
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
      
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '10px'
        }}
      >
        <Button
          type="primary"
          icon="plus"
          className="animated-add-btn"
          onClick={() => openModal()}
        >
          Add Record
        </Button>
        <Input.Search
          placeholder="Search customers..."
          onChange={(e) => setSearch(e.target.value)}
          value={search}
          style={{ width: '100%', maxWidth: 400, marginLeft: 10 }}
        />
      </div>
      
      <CustomersForm
        data={modalData.data}
        visible={modalData.visible}
        closeModal={closeModal}
        addCustomer={addCustomer}
        updateCustomer={updateCustomer}
        setLoading={setLoading}
      />
      
      <CustomersTable
        setLoading={setLoading}
        openModal={openModal}
        data={filteredCustomer}
        deleteCustomer={deleteCustomer}
      />
    </>
  )
}

export default Layout(CustomerView);